import { DataAnalytics, DataObject } from './common';
var errorMessage = 'We are currently experiencing technical difficulties and are unable to access your account.';
export var activityErrorAnalytics = {
    errorMessage: errorMessage,
    pageFunction: 'activity',
    pageKind: 'activity',
    pageName: 'error',
    pageSubFunction: ''
};
export var transactionRowAnalytics = {
    'data-type': 'transaction',
    'data-reason': DataObject.expand,
    'data-object': DataObject.button,
    'data-analytics': DataAnalytics.clickTrackingEvent
};
//# sourceMappingURL=activity.js.map